(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7488],{

/***/ 94161:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);


var redirectFirstPage = function redirectFirstPage(_ref) {
  var page = _ref.page,
      res = _ref.res,
      asPath = _ref.asPath;

  if (+page === 1) {
    // eslint-disable-next-line no-useless-escape
    var redirectUrl = asPath.replace(/[&\?]?page=1[&]?/gm, function (match) {
      if (match === '&page=1') return '';
      if (match === '?page=1') return '';
      if (match === '?page=1&') return '?';
    });

    if (res) {
      res.writeHead(301, {
        Location: redirectUrl
      });
      res.end();
    } else {
      next_router__WEBPACK_IMPORTED_MODULE_0___default().push(redirectUrl);
    }
  }
};

/* harmony default export */ __webpack_exports__["Z"] = (redirectFirstPage);

/***/ }),

/***/ 40024:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _typeSlug_; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/catalogSlice.js
var catalogSlice = __webpack_require__(35955);
// EXTERNAL MODULE: ./store/index.js + 7 modules
var store = __webpack_require__(12325);
// EXTERNAL MODULE: ./node_modules/@fh-components/fh-js-api-core/store/slices/categoriesSlice.js
var categoriesSlice = __webpack_require__(11012);
// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__(80129);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
;// CONCATENATED MODULE: ./lib/redirectWithSavedSort.js



var redirectWithSavedSort = function redirectWithSavedSort(_ref) {
  var _query$split;

  var sort = _ref.sort,
      res = _ref.res,
      asPath = _ref.asPath;
  var pathname = asPath.split('?')[0];
  var query = asPath.split('?')[1];
  var nextQuery = [].concat((0,toConsumableArray/* default */.Z)((_query$split = query === null || query === void 0 ? void 0 : query.split('&')) !== null && _query$split !== void 0 ? _query$split : []), ["sort=".concat(sort)]).join('&');
  var redirectUrl = "".concat(pathname, "?").concat(nextQuery);

  if (res) {
    res.writeHead(302, {
      Location: redirectUrl
    });
    res.end();
  } else {
    router_default().push(redirectUrl);
  }
};

/* harmony default export */ var lib_redirectWithSavedSort = (redirectWithSavedSort);
// EXTERNAL MODULE: ./lib/redirectFirstPage.js
var redirectFirstPage = __webpack_require__(94161);
// EXTERNAL MODULE: ./layouts/index.js + 22 modules
var layouts = __webpack_require__(75842);
// EXTERNAL MODULE: ./lib/handleError.js
var handleError = __webpack_require__(67408);
// EXTERNAL MODULE: ./seo/Ecommerce.js
var Ecommerce = __webpack_require__(31893);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./pages/[...typeSlug].js



var _excluded = ["pageType"];


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }














var NextPage = function NextPage(_ref) {
  var pageType = _ref.pageType,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  (0,react.useEffect)(function () {
    if (pageType === 'redirect') {
      router_default().push(props.data);
    }

    if (pageType === 'text-page') {
      if (props.data.slug.includes('contacts') || props.data.slug.includes('store')) {
        Ecommerce/* default.setPageType */.ZP.setPageType(Ecommerce/* default.PAGE_TYPES.CONTACTS */.ZP.PAGE_TYPES.CONTACTS);
      } else {
        Ecommerce/* default.setPageType */.ZP.setPageType(Ecommerce/* default.PAGE_TYPES.OTHER */.ZP.PAGE_TYPES.OTHER);
      }
    }

    if (pageType === 'catalog') {
      if (props.data.current.slug.includes('brands')) {
        Ecommerce/* default.setPageType */.ZP.setPageType(Ecommerce/* default.PAGE_TYPES.BRAND */.ZP.PAGE_TYPES.BRAND);
      } else {
        Ecommerce/* default.setPageType */.ZP.setPageType(Ecommerce/* default.PAGE_TYPES.CATEGORY */.ZP.PAGE_TYPES.CATEGORY);
      }
    }
  }, [pageType]);

  switch (pageType) {
    case 'catalog':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(layouts/* CatalogPage */.h4, _objectSpread({}, props));

    case 'text-page':
      return /*#__PURE__*/(0,jsx_runtime.jsx)(layouts/* TextPage */.xU, _objectSpread({}, props));

    default:
      return null;
  }
};

NextPage.getInitialProps = /*#__PURE__*/function () {
  var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(_ref2) {
    var _selectedCategory;

    var query, reduxStore, res, asPath, _qs$parse, typeSlug, pageQuery, selectedSorting, selectedFilters, access, pageOrCategorySlug, selectedCategory, data, isRedirect, isCatalogLink, savedSort, sortFields, hasSelectedSortInFields, params, pageData;

    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            query = _ref2.query, reduxStore = _ref2.reduxStore, res = _ref2.res, asPath = _ref2.asPath;
            _qs$parse = lib_default().parse(query, {
              arrayLimit: 100
            }), typeSlug = _qs$parse.typeSlug, pageQuery = _qs$parse.page, selectedSorting = _qs$parse.sort, selectedFilters = _qs$parse.filters, access = _qs$parse.access;
            pageOrCategorySlug = typeSlug.join('/');
            isRedirect = false;
            _context.next = 6;
            return reduxStore.dispatch((0,categoriesSlice/* getCategoryTreeBySlug */.P1)({
              slug: "/".concat(pageOrCategorySlug),
              onSuccess: function onSuccess(result) {
                if (result.page.pageType === 'redirect') {
                  isRedirect = true;
                  data = result.page.data.to;
                } else {
                  data = result.page.data;
                  selectedCategory = result.page.data.current;
                }
              },
              onError: function onError(result) {
                (0,handleError/* handleError */.S)(result);
              }
            }));

          case 6:
            if (!isRedirect) {
              _context.next = 8;
              break;
            }

            return _context.abrupt("return", {
              pageType: 'redirect',
              data: data
            });

          case 8:
            isCatalogLink = ((_selectedCategory = selectedCategory) === null || _selectedCategory === void 0 ? void 0 : _selectedCategory.type) === 'menu';

            if (!isCatalogLink) {
              _context.next = 25;
              break;
            }

            (0,redirectFirstPage/* default */.Z)({
              page: pageQuery,
              res: res,
              asPath: asPath
            });
            savedSort = (0,store/* catalogSortSelector */.tD)(reduxStore.getState());
            if (selectedSorting && savedSort !== selectedSorting) reduxStore.dispatch((0,catalogSlice/* saveSort */.jI)(selectedSorting));

            if (!(savedSort && !selectedSorting)) {
              _context.next = 16;
              break;
            }

            lib_redirectWithSavedSort({
              res: res,
              asPath: asPath,
              sort: savedSort
            });
            return _context.abrupt("return");

          case 16:
            sortFields = selectedCategory.sort_fields;
            hasSelectedSortInFields = sortFields.some(function (field) {
              return field.value === selectedSorting;
            });
            params = {
              hash: selectedCategory.hash,
              page: pageQuery || 1,
              filters: selectedFilters,
              sort: hasSelectedSortInFields ? selectedSorting : sortFields.length > 0 ? sortFields[0].value : 'new'
            };
            _context.next = 21;
            return reduxStore.dispatch((0,catalogSlice/* fetchProducts */.t2)(params));

          case 21:
            pageData = (0,catalogSlice/* getCatalogData */.zm)(reduxStore.getState());
            (0,handleError/* handleError */.S)(pageData.error);
            _context.next = 26;
            break;

          case 25:
            return _context.abrupt("return", {
              pageType: 'text-page',
              slug: pageOrCategorySlug,
              textPageType: 'page',
              access: access,
              data: data.page
            });

          case 26:
            return _context.abrupt("return", {
              pageType: 'catalog',
              data: data
            });

          case 27:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref3.apply(this, arguments);
  };
}();

/* harmony default export */ var _typeSlug_ = (NextPage);

/***/ }),

/***/ 69406:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...typeSlug]",
      function () {
        return __webpack_require__(40024);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(69406); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);